import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';

const DoctypeUsdIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  ({ size = 24, ...props }, ref) => {
    const use16px = size <= 16;

    return (
      <Icon
        data-testid="DoctypeUsd"
        ref={ref}
        size={size}
        viewBox={use16px ? VIEWBOXES._16 : VIEWBOXES._24}
        fill="none"
        {...props}
      >
        {use16px ? (
          <>
            <path
              fill="#03A9F4"
              fillRule="evenodd"
              d="M11.095 4V.5h-9.5v15h13V4h-3.5Z"
              clipRule="evenodd"
            />
            <path fill="#fff" d="M2.095 1v10h12V4h-3V1h-9Z" />
            <path
              fill="#008ECE"
              d="m14.595 7.5-3.5-3.5h3.5v3.5Z"
              opacity=".2"
            />
            <path fill="#008ECE" d="m11.095.5 3.5 3.5h-3.5V.5Z" />
            <path
              fill="#7DD1F6"
              d="M8.434 3.613V3l2.33.736v2.698l-.613-.245V4.226l-1.717-.613Z"
            />
            <path
              fill="#03A9F4"
              d="M6.717 3.981v-.735l3.189 1.103v3.557l-.736-.245V4.84l-2.453-.859Z"
            />
            <path
              fill="#208ECD"
              d="M8.925 5.085V9.5L5 8.15V3.737l3.925 1.349ZM5.735 7.66l2.453.859V5.821l-2.452-.859V7.66Z"
            />
            <path
              fill="#7DD1F6"
              d="M5.981 7.415V5.453l1.84.613V8.03l-1.84-.614Z"
            />
            <path
              fill="#fff"
              d="M10.392 14.46h-.785v-2.427h.81c.238 0 .442.049.613.146a.96.96 0 0 1 .392.416c.091.18.137.396.137.648 0 .253-.046.47-.138.651a.972.972 0 0 1-.399.42 1.272 1.272 0 0 1-.63.146Zm-.42-.32h.4a.923.923 0 0 0 .46-.105.657.657 0 0 0 .276-.304c.06-.133.091-.296.091-.488 0-.19-.03-.352-.091-.485a.644.644 0 0 0-.27-.302.878.878 0 0 0-.443-.103h-.422v1.787Zm-1.189-1.47a.346.346 0 0 0-.156-.26.601.601 0 0 0-.346-.094c-.1 0-.186.016-.258.048a.397.397 0 0 0-.17.128.302.302 0 0 0-.06.183.27.27 0 0 0 .041.15.36.36 0 0 0 .108.105c.045.028.093.05.144.07.052.018.101.033.149.045l.237.062c.077.019.156.044.238.077a.956.956 0 0 1 .226.128.57.57 0 0 1 .233.477c0 .137-.035.26-.106.366a.711.711 0 0 1-.307.252 1.15 1.15 0 0 1-.485.093c-.181 0-.339-.03-.471-.087a.726.726 0 0 1-.312-.245.711.711 0 0 1-.124-.38h.367a.377.377 0 0 0 .085.22c.05.058.115.1.193.13a.78.78 0 0 0 .26.04.735.735 0 0 0 .276-.048.462.462 0 0 0 .192-.137.326.326 0 0 0 .07-.208.25.25 0 0 0-.062-.176.455.455 0 0 0-.164-.114 1.61 1.61 0 0 0-.234-.08l-.287-.077a1.116 1.116 0 0 1-.462-.234.524.524 0 0 1-.169-.407c0-.14.038-.262.114-.366a.747.747 0 0 1 .308-.243c.13-.059.275-.088.438-.088.164 0 .31.029.435.086a.733.733 0 0 1 .298.239.6.6 0 0 1 .114.346h-.353Zm-2.223-.637h.368v1.596c0 .17-.04.32-.12.452a.836.836 0 0 1-.337.308 1.099 1.099 0 0 1-.508.11 1.1 1.1 0 0 1-.507-.11.837.837 0 0 1-.336-.308.851.851 0 0 1-.12-.452v-1.596h.366V13.6c0 .11.024.208.072.293a.525.525 0 0 0 .208.202.66.66 0 0 0 .317.072c.123 0 .23-.024.319-.072a.507.507 0 0 0 .206-.202.585.585 0 0 0 .072-.293v-1.566Z"
            />
          </>
        ) : (
          <>
            <path
              fill="#03A9F4"
              d="M2.392 23.25h19.5V6h-5.25V.75H2.392v22.5Z"
            />
            <path fill="#fff" d="M3.142 1.5v15h18V6h-4.5V1.5h-13.5Z" />
            <path
              fill="#008ECE"
              d="M21.892 11.25 16.642 6h5.25v5.25Z"
              opacity=".2"
            />
            <path fill="#008ECE" d="M16.642.75 21.892 6h-5.25V.75Z" />
            <path
              fill="#7DD1F6"
              d="M12.65 5.42V4.5l3.496 1.104V9.65l-.92-.368V6.34l-2.575-.92Z"
            />
            <path
              fill="#03A9F4"
              d="M10.076 5.972V4.868l4.783 1.656v5.335l-1.104-.368V7.26l-3.68-1.288Z"
            />
            <path
              fill="#208ECD"
              d="M13.387 7.627v6.623L7.5 12.226V5.604l5.887 2.023ZM8.604 11.49l3.679 1.289V8.73l-3.68-1.287v4.046Z"
            />
            <path
              fill="#7DD1F6"
              d="M8.972 11.123V8.18l2.76.92v2.943l-2.76-.92Z"
            />
            <path
              fill="#fff"
              d="M15.588 21.69H14.41v-3.64h1.216c.356 0 .663.073.918.218.256.145.453.353.589.624.137.27.206.594.206.972 0 .38-.07.705-.208.978a1.457 1.457 0 0 1-.597.629c-.26.145-.576.218-.946.218Zm-.629-.48h.6c.276 0 .507-.053.69-.157a.985.985 0 0 0 .413-.457c.091-.2.137-.444.137-.732 0-.285-.046-.528-.137-.727a.966.966 0 0 0-.404-.453 1.318 1.318 0 0 0-.666-.154h-.633v2.68Zm-1.784-2.204a.52.52 0 0 0-.235-.391.902.902 0 0 0-.519-.14.966.966 0 0 0-.387.07.596.596 0 0 0-.254.192.453.453 0 0 0-.09.276c0 .086.02.161.061.224a.542.542 0 0 0 .162.158c.067.041.14.076.217.105.077.027.15.05.222.067l.355.093c.116.028.236.067.357.115.123.049.236.113.34.192a.855.855 0 0 1 .35.716c0 .207-.053.39-.16.55-.105.16-.259.286-.46.378-.2.092-.443.139-.727.139a1.77 1.77 0 0 1-.707-.13c-.2-.087-.355-.21-.468-.368a1.066 1.066 0 0 1-.186-.569h.55a.567.567 0 0 0 .129.33.69.69 0 0 0 .29.193c.118.041.247.062.388.062.156 0 .294-.024.415-.073a.694.694 0 0 0 .287-.206.488.488 0 0 0 .105-.31.382.382 0 0 0-.092-.266.683.683 0 0 0-.247-.17 2.412 2.412 0 0 0-.35-.12l-.43-.117c-.292-.079-.523-.196-.693-.35a.786.786 0 0 1-.255-.611.91.91 0 0 1 .171-.55c.114-.155.268-.277.462-.364.194-.087.414-.131.658-.131.246 0 .463.043.652.13.19.086.339.205.448.357a.9.9 0 0 1 .17.519h-.53ZM9.84 18.05h.551v2.394c0 .254-.06.48-.18.677-.119.195-.287.35-.504.462a1.65 1.65 0 0 1-.762.167c-.29 0-.544-.056-.76-.167a1.255 1.255 0 0 1-.506-.462 1.277 1.277 0 0 1-.179-.677V18.05h.55v2.35c0 .164.035.31.108.438a.787.787 0 0 0 .31.302.988.988 0 0 0 .477.109.992.992 0 0 0 .478-.109.76.76 0 0 0 .31-.302.878.878 0 0 0 .107-.439v-2.35Z"
            />
          </>
        )}
      </Icon>
    );
  },
) as IconWithRender;

DoctypeUsdIcon.displayName = 'DoctypeUsdIcon';
DoctypeUsdIcon.renderIcon = (props) => <DoctypeUsdIcon {...props} />;
export default DoctypeUsdIcon;
